import { render, staticRenderFns } from "./linkCard.vue?vue&type=template&id=53f011a2&scoped=true&"
import script from "./linkCard.vue?vue&type=script&lang=js&"
export * from "./linkCard.vue?vue&type=script&lang=js&"
import style0 from "./linkCard.vue?vue&type=style&index=0&id=53f011a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f011a2",
  null
  
)

export default component.exports